import { render } from "./MedicalDashboard.vue?vue&type=template&id=0d438f25"
import script from "./MedicalDashboard.vue?vue&type=script&lang=js"
export * from "./MedicalDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__